import { makeStyles } from "@material-ui/core/styles";

/**
 * メニューの横幅.
 *
 * @type {number}
 */
const drawerWidth = 200;

/**
 * ブレークポイント.
 *
 * @type {string}
 */
const breakpoint = "md";

/**
 * スタイルHook.
 *
 * @type {object}
 */
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(breakpoint)]: {
      display: "none",
    },
  },
  signOutButton: {
    marginLeft: "auto",
  },
  drawer: {
    [theme.breakpoints.up(breakpoint)]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    width: drawerWidth,
  },
  toolbar: theme.mixins.toolbar,
  link: {
    textDecoration: "none",
    color: theme.palette.text.primary,
  },
  listItemIcon: {
    minWidth: theme.spacing(4),
  },
  page: {
    flexGrow: 1,
    padding: theme.spacing(3),
    minWidth: 800,
  },
  breadcrumbs: {
    padding: theme.spacing(0, 0, 2, 0),
  },
  dialogContent: {
    padding: theme.spacing(2, 5),
  },
  dialogActions: {
    padding: theme.spacing(3, 2, 2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default useStyles;
